import { render, staticRenderFns } from "./EntityIdLink.vue?vue&type=template&id=88d99054&scoped=true"
import script from "./EntityIdLink.vue?vue&type=script&lang=ts"
export * from "./EntityIdLink.vue?vue&type=script&lang=ts"
import style0 from "./EntityIdLink.vue?vue&type=style&index=0&id=88d99054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d99054",
  null
  
)

export default component.exports